<template>
  <div>
    <div class="products">
      <ProductTitle :editable="type == 'confirmPage'"></ProductTitle>
      <div class="box gray-box mobileBox">
        <ul class="box-body mobile-list-box" style="padding: 30px;">
          <li class="clearfix" type="flex" v-for="(goods, idx) in goodsList">
            <div class="copyGood" v-if="type !== 'confirmPage'" id="copy" @click.stop="copySetting">
              <span @click="showCopy(goods)"><i class="el-icon-more-outline moreIco">
              
              </i></span>
              <div v-show="goods.showCopy" id="box" class="copybtn" style="position:absolute;">
                <p  class="copyTxT">
                  <AddProducts v-on:success="notifySuccess" v-if="type !== 'confirmPage'" :copyform="goods" style="margin-right: 10px;" class="mobile-edit"><span style="font-size:14px;" >复制商品</span></AddProducts>
                </p>
              </div>
              <!-- <el-popover
                placement="bottom"
                width="80"
                trigger="click"
                v-model="goods.showCopy">
                <p  class="copyTxT">
                  <AddProducts v-on:success="notifySuccess" v-if="type !== 'confirmPage'" :copyform="goods" style="margin-right: 10px;" class="mobile-edit"><span style="font-size:14px;" >复制任务</span></AddProducts>
                </p>
              </el-popover> -->
            </div>

            <!-- <div class="copyGood isMobile" v-if="type !== 'confirmPage'">
              <el-dropdown trigger="click" :hide-on-click="false">
                <span class="el-dropdown-link">
                  <i class="el-icon-more-outline moreIco"></i>
                </span>
                <el-dropdown-menu slot="dropdown" class="copyButton">
                  <el-dropdown-item><AddProducts  v-if="type !== 'confirmPage'" :copyform="goods" class="mobile-edit"><span style="font-size:14px;" >复制商品</span></AddProducts></el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div> -->
            <div class="img-container  mobileImg" @click="uploadPicture(goods)">
              <div :class="!goods.picture?'noPicture':''">
                <img v-if="goods.picture" :src="goods.picture"/>
                <img v-if="!goods.picture" src="../../../ico/uploadpic@2x.png"/>
              </div>
            </div>
            <div class="des-container mobile-des" :span="18">
              <h4><a :href='goods.website.substr(0,7).toLowerCase() == "http://" || goods.website.substr(0,8).toLowerCase() == "https://" ? goods.website : "http://"+ goods.website' target="_blank">{{goods.name}}</a></h4>
              <p class="spec"><span>规格：</span>{{goods.spec}}</p>
              <p v-if="type === 'confirmPage'"><span>数量：</span>{{goods.number}}</p>
              <div class="bottom-container mobile-bottom-container">
                <AddProducts v-if="goods.good_id =='0'" :product="goods" style="margin-right: 10px;" class="mobile-edit"><el-button class="gray small mobile-button" type="info">编辑</el-button></AddProducts>
                <el-button v-if="type === 'shoppingCart'" class="gray small mobile-button" type="info" @click="del(idx)">移除</el-button>
                <el-button v-if="type === 'buyLater'" class="gray small mobile-button" type="info" @click="add(idx, goods)">加入购物车</el-button>
                <el-select v-if="type === 'shoppingCart'" class="inline-block" v-model="goods.number" placeholder="">
                  <el-option
                    v-for="item in 999"
                    :key="item"
                    :label="item"
                    :value="item">
                  </el-option>
                </el-select>
                <div class="price-con" :class="{'float-right': type !== 'confirmPage'}" v-if="goods.discounted_price != goods.price">
                  <del>{{goods.price|currency(taskInfo.currency_symbol)}}</del>
                  <p>{{(goods.discounted_price || goods.price)|currency(taskInfo.currency_symbol)}}</p>
                </div>
                <div class="price-con" :class="{'float-right': type !== 'confirmPage'}" v-if="goods.discounted_price == goods.price">
                  <p style="color:#000000;"> {{(goods.price)|currency(taskInfo.currency_symbol)}}</p>
                </div>
              </div>
            </div>
            <div class="bg-black" v-if="goods.completion">
              <div  class="dialog mobile-dialog" style="margin-top: 15vh">
                <div class="text-center redirct">
                    <div class="sourcePicture text" :class="source =='远程'?'source':''" @click="remote()">远程图片</div><div class="text">或</div><div @click="local()" class="sourcePicture text" :class="source =='本地'?'source':''">本地图片</div>
                    <div class="remote" v-if="source=='远程'">
                      <ul class="error-messages" v-if="!isEmptyErrors">
                        <li>{{error}}</li>
                      </ul>
                      <el-input ref="remotePicture" v-model="goods.remotePicture" placeholder="请复制图片地址或截图粘贴到输入框内或手动输入" v-paste="handlePaste"  style="margin-bottom:10px;"></el-input>
                      <el-button size="small" type="info" @click="confirm(goods)">确定</el-button><div class="del" @click="onUploadCancel(goods)">取消</div>
                    </div>
                    <uploader
                    v-if="source =='本地'"
                    icon="ico ico-uploadpic mt15"
                    :item="goods"
                    :action="API_HOST + '/api/order.php?api=upload_good_picture'"
                    v-on:onUploadSuccess="onUploadSuccess"
                    v-on:onUploadCancel="onUploadCancel(goods)"></uploader>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Uploader from '../../../components/Uploader';
import ProductTitle from './ProductTitle'
import { API_HOST, FILE_HOST } from '../../../services/constant.js'
import AddProducts from './AddProducts'
import api from '../../../services/api.js'
let _ = require('lodash')
let $ = require('jQuery')


export default {
  name: 'ProductList',
  props: ['type', 'goodsList'],
  components: {
    uploader: Uploader,
    ProductTitle: ProductTitle,
    AddProducts: AddProducts
  },
  created(){
    document.addEventListener('click',e => {
      var box = document.getElementById('box')
        console.log(box)
      if(box){
        if(box.contains(e.target)){
          
        }else{
          _.each(this.goodsList,item => {
            item.showCopy = false
          })
          this.$forceUpdate()
        }
      }
      
    })
  },
  mounted(){
    this.$nextTick(function() {
      document.addEventListener("click", e => {
      });
    });
  },
  computed: {
    taskInfo () {

	    return this.$store.state.taskInfo
    }
  },
  data () {
    return {
      dialogFormVisible: false,
      form: {
        region: '',
        value: ''
      },
      options: [{
        value: 1,
        label: 1
      }],
      API_HOST: API_HOST,
      completion: false,
      source: '远程',
      isEmptyErrors: true,
      error: '',
      updateGood: null
    }
  },
  methods: {
    copySetting (e){
      console.log(e)
      if(this.$el.contains(e.target)){
      }else{
      }
    },
    showCopy(goods){
      _.each(this.goodsList,item => {
        if(item.id != goods.id){
          item.showCopy = false
        }
      })
      goods.showCopy = !goods.showCopy
      this.$forceUpdate()
    },
    addProduct: function () {
      this.dialogFormVisible = true
    },
    remote () {
      this.source = '远程'
    },
    local () {
      this.source = '本地'
      this.isEmptyErrors = true
      this.error = ''
    },
    confirm (goods) {
      console.log(goods.remotePicture)
      if(!goods.remotePicture){
        this.isEmptyErrors = false
        this.error = '图片地址不能为空'
        return
      }
      goods.picture = goods.remotePicture
      this.$forceUpdate()
      goods.completion = false
      this.source = '远程'
      this.isEmptyErrors = true
      this.error = ''
    },
    uploadPicture (goods) {
      if(goods.good_id != 0) {
        return
      }
      goods.completion = true
      this.$nextTick(()=>{
          this.$refs.remotePicture.focus();
        })
      this.updateGood = goods
      this.$forceUpdate()
    },
    onUploadCancel (goods) {
      goods.completion = false
      this.source = '远程'
      this.isEmptyErrors = true
      this.error = ''
      this.$forceUpdate()
    },
    onUploadSuccess: function (res) {
      let result = res.response.result
      for (let goods of this.goodsList) {
        if (goods.id === res.item.id) {
          goods.picture = result
          goods.completion = false
          this.source = '远程'
          this.$forceUpdate()
          return
        }
      }
    },
    edit (goods) {

    },
    del (idx) {
      this.goodsList.splice(idx, 1)
      if (this.goodsList.length === 0) {
        this.taskInfo.business_name = null
        this.taskInfo.business_website = null
        this.taskInfo.business_id = null
        this.taskInfo.website = null
        this.taskInfo.business = null
      }
      this.$store.commit('updateTaskInfo', this.taskInfo)
    },
    add (idx, goods) {
      this.taskInfo.goods_list.push(goods)
      this.del(idx)
      this.$store.commit('updateTaskInfo', this.taskInfo)
    },
    buyLater (idx, goods) {
      this.taskInfo.later_goods_list.push(goods)
      this.del(idx)
      this.$store.commit('updateTaskInfo', this.taskInfo)
    },
    async uploadPictureByPaste (picture) {
      let res = await api.post(this, {
        path: 'order.php',
        api: 'upload_good_picture',
        data: picture,
        loading: 'loading'
      })
      if(res.body.status == 'ok'){
        let url = res.body.result
        this.updateGood.picture = url
        console.log(this.updateGood)
        this.updateGood.completion = false
        this.$forceUpdate()
      }
      

    },
    handlePaste(e) { 
            console.log(e.clipboardData.items[0].type)
          if(e.clipboardData && e.clipboardData.items[0] && e.clipboardData.items[0].type && e.clipboardData.items[0].type.indexOf('plain') > -1){
            return
          }
          let reader = new FileReader()
          let file = null
          let that = this
          if (e.clipboardData && e.clipboardData.items[0] && e.clipboardData.items[0].type && e.clipboardData.items[0].type.indexOf('image') > -1) { //这里就是判断是否有粘贴进来的文件且文件为图片格式
            file = e.clipboardData.items[0].getAsFile();
            reader.readAsDataURL(file)
            reader.onload = function (e){
              that.url = e.target.result
              let fd = new FormData()
              let blob = dataURItoBlob(that.url)
              fd.append('good_picture', file);
              that.uploadPictureByPaste(fd)
                // console.log(that.url)
            }
            

          }else {
            this.isEmptyErrors = false
            this.error = '上传的图片支持截图但无法复制本地图片且无法同时复制多张图片'
            // this.$message({
            //   type: 'warning',
            //   message: '上传的图片支持截图但无法复制本地图片且无法同时复制多张图片'
            // })
            return;
          }
      },
  }
}
function dataURItoBlob(dataURI) {
    var byteString = atob(dataURI.split(',')[1]);
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    var ab = new ArrayBuffer(byteString.length);
    var ia = new Uint8Array(ab);
    for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], {type: mimeString});
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.copyGood{
  // position: absolute; 
  // right: -7px;
  // top: 0;
  // z-index: 999;
  position: relative;
  float: right;
  cursor: pointer;

  
}
.copybtn{
  position: absolute;
  left: -90px;
  top: -11px;
  width: 90px;
  border: 1px solid #d7d7d7;
  line-height: 36px;
  padding: 0 5px;
  margin: 0;
  font-size: 14px;
  color: #606266;
  cursor: pointer;
  background: #fff;
}
.copyTxT{
  text-align: center;
  padding-left: 10px;
}
.moreIco{
  transform: rotate(90deg);
}
.products {
  & > h3 {
    line-height: 25px;
  }

  & > p {
    line-height: 18px;
    margin-bottom: 10px;
    color: #666666;
  }
  a{
    color: #000000;
  }
  .isMobile{
    display: none;
  }
  .notMobile{
    display: block;
  }
}
.img-container {
  text-align: center;
  width: 170px;
  height: 170px;
  overflow: hidden;
  float: left;
  position: relative;

  .noPicture {
    // padding: 30px;
  }

  div {
    width: 170px;
    height: 170px;
  }

  img {
    width: 100%;
    position: absolute;
    left: 0;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
  }
}
.des-container {
  // position: relative;
  width: 100%;
  height: 170px;
  padding-right: 190px;
  margin-left: 190px;

  h4 {
    font-size:14px;
    line-height:20px;
    margin-bottom: 3px;
  }

  p {
    font-size:14px;
    line-height:20px;

    span {
      color: #888888;
    }
  }
  .spec{
    word-break: break-all;
  }
  .bottom-container {
    position: absolute;
    padding-right: 190px;
    bottom: 30px;
    width: 100%;
  }
}

.box-body {
  & > li {
    margin-bottom: 30px;
    padding-bottom: 30px;
    border-bottom: 1px solid #DEE2EC;
    position: relative;

    &:last-child {
      margin-bottom: 0;
      padding-bottom: 0;
      border-bottom: none;
      .des-container{
        .bottom-container{
          bottom: 0px !important;
        }
      } 
    }
  }
}

.price-con {
  del {
    color: #B0B4BF;
  }

  p {
    margin-top: 2px;
    color: #FF4650;
  }
}
.bg-black {
  position: fixed;
  display: block;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  margin: 0;
  z-index: 2111;
  background: rgba(0,0,0,.3);
}
.dialog {
  width: 450px;
  position: relative;
  margin: 0 auto 50px;
  background: #ffffff;
  box-shadow: 0 1px 3px rgba(0,0,0,.3);
  padding: 20px;
}
.redirct {
    font-size:24px;
    line-height:33px;
    .source {
      color: #337ab7;
    }

    .text {
      display: inline-block;
      margin-right: 10px;
    }
    .sourcePicture:hover {
      color: #337ab7;
      cursor: pointer;
    }

    .remote {

      .error-messages {
        display: block;
        background-color: #fff1f1;
        padding: 10px;
        text-align: center;
        color: #ff4650;
        line-height: 17px;
        margin-bottom: 10px;
        border-radius: 5px;
        li {
          font-size: 12px;
        }
      }
      .del {
        padding: 0px 15px;
        display: inline-block;
        border: 1px solid #cccccc;
        font-size: 12px;
        height: 32px;
        vertical-align: bottom;
        margin-left: 10px;
        cursor: pointer;
      }
    }
}
@media screen and (max-width:770px){
  .copyGood{
    right: -5px !important;
  }
  .mobileBox {
    margin-bottom: 10px !important;
  }
  .mobile-list-box {
    padding: 15px !important;
    .isMobile{
      display: block;
    }
    .notMobile{
      display: none;
    }
  }
  .mobileImg {
    height: 90px;
    width: 90px;
    z-index: 1;
    margin-right: 5px;
    div {
      height: 100% !important;
      width: 100% !important;
      padding: 5px;

       img {
          height: 90px !important;
          width: 90px !important;
        }
    }
  }
  .mobile-des {
    padding-right: 0px !important;
    margin-left: 0px !important;
    height: 140px !important;
    .mobile-bottom-container {
      padding-right: 0px !important;
      .mobile-edit {
        margin-right: 2px !important;
      }
      .mobile-button {
        padding: 10px 10px !important;
      }
      .mobile-button+.mobile-button {
        margin-left: 2px !important;
      }
      .mibile-select {
        margin-left: 2px !important;
        
      }
    }
  }
  .mobile-dialog {
    width: 100% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/publish_task/product/ProductList.vue